import './styles.scss'
import React from 'react'
import ClickOutHandler from 'react-onclickout'

import { getStaticImage } from 'utils/statics'

const InputChipsWithSearchUI = ({
  values,
  onChange,
  placeholder,
  buttons,
  hiddenButtons,
  isOpenResultsContainer,
  setIsOpenResultsContainer,
  data,
  handleEvents,
  handleDeleteChip,
  lockedChips,
  customClassName
}) => (
  <div className={`input-chips ${customClassName ? customClassName : ''}`}>
    <div className='input-chips__chips-container'>
      {values.chips?.map((chip, index) => (
        <div
          key={index}
          className={`input-chips__chip ${lockedChips && values.chips.length <= lockedChips.value ? 'input-chips__chip--locked' : ''}`}
          style={{ backgroundColor: !chip.isValid ? '#ff9b9b' : null }}
        >
          <span>{chip.name || chip.value}</span>
          <button onClick={() => handleDeleteChip({ chipId: chip.id })}>
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' />
            </figure>
          </button>
        </div>
      ))}
      <ClickOutHandler onClickOut={() => setIsOpenResultsContainer(false)}>
        <div className='input-chips__input-container'>
          <input
            className='input-chips__input'
            type='text'
            placeholder={placeholder && !values.chips?.length ? placeholder : ''}
            value={values.input || ''}
            onChange={event => onChange({ ...values, input: event.target.value.replace(/\s/g, '') })}
            onKeyDown={event => handleEvents({ key: event.key })}
            onFocus={() => setIsOpenResultsContainer(true)}
          />
          {isOpenResultsContainer && data.length ? (
            <div className='input-chips__results-container'>
              {data.map((item, index) => (
                <div
                  key={index}
                  className='input-chips__result-banner'
                  onClick={() => handleEvents({ key: ' ', data: item })}
                >
                  <figure className='input-chips__result-avatar'>
                    <img
                      src={item.avatar || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
                      alt={item.name}
                      onError={event => {
                        event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
                        event.onerror = null
                      }}
                    />
                  </figure>
                  <div className='input-chips__result-info'>
                    <div className='input-chips__result-name'>
                      <strong className='text-ellipsis' title={item.name}>{item.name}</strong>
                      {item.companyName ? (
                        <span className='text-ellipsis' title={item.companyName}>{item.companyName}</span>
                      ) : null}
                    </div>
                    {item.email ? (
                      <span>{item.email}</span>
                    ) : (
                      <span>{item.phone}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          {Object.keys(buttons).length > 0 && (
            <div className='input-chips__buttons-container'>
              {Object.keys(buttons).map((button, index) => {
                if (!hiddenButtons.find(hiddenButton => hiddenButton === button)) return (
                  <button
                    key={index}
                    type='button'
                    onClick={() => buttons[button].onClick()}
                  >
                    {buttons[button].title}
                  </button>
                )

                return null
              })}
            </div>
          )}
        </div>
      </ClickOutHandler>
    </div>
  </div>
)

export default InputChipsWithSearchUI
